import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  username: "",
  userpass: { username: "", password: "" },
  userdetails: {},
  access_token: "",
  refresh_token: "",
  login_id: "",
  userdepartment: {},
  userpermission: [],
  employee: {},
  document_id:"",
  is_first_login: false,
  login_time:"",
  bookmarks: {},
};

export const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    setUsername: (state, action) => {
      state.username = action.payload;
    },
    setUserPass: (state, action) => {
      state.userpass = action.payload;
    },
    setUserDetails: (state, action) => {
      state.userdetails = action.payload;
    },
    setAccessToken: (state, action) => {
      state.access_token = action.payload;
    },
    setRefreshToken: (state, action) => {
      state.refresh_token = action.payload;
    },
    setLoginID: (state, action) => {
      state.login_id = action.payload;
    },
    setUserDepartment: (state, action) => {
      state.userdepartment = action.payload;
    },
    setUserPermission: (state, action) => {
      state.userpermission = action.payload;
    },
    setEmployee: (state, action) => {
      state.employee = action.payload;
    },
    setis_first_login: (state, action) => {
      state.is_first_login = action.payload;
    },
    setlogin_time: (state, action) => {
      state.login_time = action.payload;
    },
    setUserBookmarks: (state, action) => {
      state.bookmarks = action.payload;
    },

    setresetAuthenticationState: (state, action) => {
      state.username = "";
      state.userpass = { username: "", password: "" };
      state.access_token = "";
      state.refresh_token = "";
      state.userdetails = null;
      state.login_id = "";
      state.userdepartment = {};
      state.userpermission = [];
      state.employee = null;
      state.is_first_login= false;
      state.login_time = "";
      localStorage.removeItem("userdetails");
    },
    setDocumentId:(state, action)=>{
      state.document_id=action.payload
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  setUsername,
  setUserPass,
  setUserDetails,
  setAccessToken,
  setRefreshToken,
  setLoginID,
  setUserDepartment,
  setEmployee,
  setUserPermission,
  setresetAuthenticationState,
  setDocumentId,
  setis_first_login,
  setlogin_time,
  setUserBookmarks,
  
} = authenticationSlice.actions;

export default authenticationSlice.reducer;
